"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = Popover;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_aria_1 = require("react-aria");
/** Popover is used for generating menus and list-boxes */
function Popover(props) {
    const { triggerRef, popoverRef, positionProps, children, onClose, isOpen, ...others } = props;
    const { overlayProps } = (0, react_aria_1.useOverlay)({
        onClose,
        isOpen,
        isDismissable: true,
        shouldCloseOnInteractOutside: (e) => {
            // By default when passing `isDismissable: true` then Popover will `stopPropagation` of the PointerDown event, which is used nearly everywhere in React-Aria (like for clicking buttons)
            // We do not want that propagation to be stopped, but we still want the overlay to be dismissable.
            // When providing `isDimissable: true`, then you can also provide this callback function, `shouldCloseOnInteractOutside`
            // By returning `false` in this function it will no longer call `stopPropagation`, but it also will not call `onHide` for us, so we need to call `onClose` ourselves.
            var _a;
            // If we clicked the trigger element (or within it), then that will call a `state.toggle` for us.
            // Return early if that happens.
            if ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e)) {
                return true;
            }
            // Do not close the Popover if the user is interacting with a tribute menu, dialog or alert on top of it, otherwise close it.
            return !(e.closest(".tribute-container") || e.closest("[role='dialog']") || e.closest("[role='alert']"));
        },
        ...others,
    }, popoverRef);
    return ((0, jsx_runtime_1.jsx)(react_aria_1.OverlayContainer, { children: (0, jsx_runtime_1.jsxs)("div", { ...overlayProps, ...positionProps, ref: popoverRef, children: [children, (0, jsx_runtime_1.jsx)(react_aria_1.DismissButton, { onDismiss: () => onClose() })] }) }));
}
